export default "__VITE_ASSET__C7Up1hxI__"